export const commissionTypes = [
  { label: 'Percentage', value: 'percentage' },
  { label: 'Per Transaction Fee', value: 'perTxFee' }
]
